var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"star-icon",class:{ 'star-icon_active': _vm.active },attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.91L12 17.77 5.82 21.05 7 14.14 2 9.27l6.91-1.01L12 2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }